import { AppProvider } from '@app/app-provider';
import AppRouter from '@app/app-router';

export const App = () => {
  return (
    <AppProvider>
      <AppRouter />
    </AppProvider>
  );
};
